import {Component, React, observer} from '$src/handy'
import setNotificationsLastSeen from '$src/api/endpoints/users/setNotificationsLastSeen'
import * as css from './Header.css'
import BellIcon from 'react-icons/lib/fa/bell-o'
import {Link} from 'react-router-dom'
import { findDOMNode } from 'react-dom'
import GenericButton from '../GenericButton'
import Badge from '../Badge'
import NotificationsMenu from './NotificationsMenu'
import newsecLogo from './newsec-logo.png'
interface State {
  notificationsMenuOpen: boolean
}
@observer
export default class Header extends Component<{}, State> {
  buttonRef: any
  buttonNode: any

  constructor(props: {}, context: any) {
    super(props, context)
    this.state = {
      notificationsMenuOpen: false,
    }
  }

  componentDidMount() {
    this.buttonNode = findDOMNode(this.buttonRef)
  }

  updateLastSeen = () => {
    const userId = this.store.auth.getMyId()
    if (userId)
      this.store.users.updateNotificationsLastSeen(userId)
  }

  setButtonRef = (ref: React.Ref<HTMLElement>) => {
    this.buttonRef = ref
  }

  handleIconButtonClick = () => {
    const {notificationsMenuOpen} = this.state

    this.toggleNotificationsMenu(!notificationsMenuOpen)

    if (!notificationsMenuOpen) {
      this.callEndpoint(setNotificationsLastSeen, {
        id: this.store.auth.getMyId(),
      }).then(
        () => {
          this.updateLastSeen()
        },
        (error: any) => {
          console.log('error', error);
        },
      )
    }
  }

  toggleNotificationsMenu = (open: boolean) => {
    this.setState(() => ({ notificationsMenuOpen: open }))
  }

  render() {
    const {notificationsMenuOpen} = this.state
    const {auth, notifications, users} = this.store

    const nots = notifications.status === 'Loaded' ? notifications.getNormal() : []
    const userId = auth.getMyId() as string
    const user = users.byId.get(userId)
    const userSeenNots =
      user &&
      user.notificationsLastSeen &&
      nots.length &&
      nots[0] &&
      new Date(nots[0].updatedAt) < new Date(user.notificationsLastSeen) ||
      nots.length === 0

    return (
      <div className={css.container}>
        <Link to="/" className={css.logo}>
          <img src={newsecLogo} alt="Newsec Logo" className={css.newsecLogo} />
          <div className={css.theLittleTextThingy}>Vallu</div>
        </Link>
        {this.store.auth.getState().isLoggedIn && (
          <div className={css.right}>
            <GenericButton
              variant="icon"
              onClick={this.handleIconButtonClick}
              ref={this.setButtonRef}
            >
              <Badge
                color="var(--color-brand)"
                badgeContent={nots.length}
                visible={!userSeenNots}
              >
                <BellIcon style={{height: '25px', width: '25px'}} />
              </Badge>
            </GenericButton>
            <NotificationsMenu
              isOpen={notificationsMenuOpen}
              onClose={() => this.toggleNotificationsMenu(false)}
              data={nots}
              buttonNode={this.buttonNode}
            />
            <Link className={css.logout} to="/logout">
              Log out
            </Link>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/PageLayout/Header.tsx